module.exports = __webpack_public_path__ + "img/22.fe591635.jpg";